export function buildNovelDraftSequence(canonicalScenes, chapters, getSceneId) {
  const scenes = Array.isArray(canonicalScenes) ? canonicalScenes : [];
  const savedChapters = Array.isArray(chapters) ? chapters : [];

  // Older stories without a saved Chapter structure keep their existing order.
  if (!savedChapters.length) {
    return scenes.map((scene, index) => ({
      scene,
      hasSavedChapters: false,
      isUnassigned: false,
      chapterIndex: -1,
      chapterTitle: "",
      scenePosition: index + 1,
    }));
  }

  const sceneById = new Map();
  for (const scene of scenes) {
    const id = String(getSceneId(scene) || "").trim();
    if (id && !sceneById.has(id)) {
      sceneById.set(id, scene);
    }
  }

  const placed = new Set();
  const sequence = [];
  savedChapters.forEach((chapter, chapterIndex) => {
    let scenePosition = 0;
    const sceneIds = Array.isArray(chapter?.sceneIds) ? chapter.sceneIds : [];
    for (const rawId of sceneIds) {
      const scene = sceneById.get(String(rawId || "").trim());
      if (!scene || placed.has(scene)) continue;
      placed.add(scene);
      scenePosition += 1;
      sequence.push({
        scene,
        hasSavedChapters: true,
        isUnassigned: false,
        chapterIndex,
        chapterTitle: String(chapter?.title || "").trim(),
        scenePosition,
      });
    }
  });

  // Unassigned Canon remains visible after the manuscript, never dropped.
  let unassignedPosition = 0;
  for (const scene of scenes) {
    if (placed.has(scene)) continue;
    placed.add(scene);
    unassignedPosition += 1;
    sequence.push({
      scene,
      hasSavedChapters: true,
      isUnassigned: true,
      chapterIndex: -1,
      chapterTitle: "",
      scenePosition: unassignedPosition,
    });
  }
  return sequence;
}
